// src/components/IdeaCreateModal.jsx
import React, { useState } from 'react';
import { X } from 'lucide-react';
import IdeaForm from './IdeaForm';

function IdeaCreateModal({ isOpen, onClose, onSubmit, setHasUnsavedChanges }) {
  const [formData, setFormData] = useState({
    idea: '',
    description: '',
    tags: [],
    status: 'Drafted',
    rating: '0',
    subtasks: [],
    lessonsLearned: '',
    resources: []
  });

  if (!isOpen) return null;

  const handleChange = (updatedData) => {
    setFormData(updatedData);
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSubmit(formData);
    // Reset form
    setFormData({
      idea: '',
      description: '',
      tags: [],
      status: 'Drafted',
      rating: '0',
      subtasks: [],
      lessonsLearned: ''
    });
    if (setHasUnsavedChanges) {
      setHasUnsavedChanges(false);
    }
    onClose();
  };

  const handleCancel = () => {
    if (window.confirm('Are you sure you want to cancel? Any unsaved changes will be lost.')) {
      setFormData({
        idea: '',
        description: '',
        tags: [],
        status: 'Drafted',
        rating: '0',
        subtasks: [],
        lessonsLearned: ''
      });
      if (setHasUnsavedChanges) {
        setHasUnsavedChanges(false);
      }
      onClose();
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" 
        onClick={handleCancel}
      />
      
      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
              Add New Idea
            </h2>
            <button
              onClick={handleCancel}
              className="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
              aria-label="Close modal"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6">
            <IdeaForm
              formData={formData}
              setFormData={handleChange}
              handleSubmit={handleSubmit}
              handleCancel={handleCancel}
              autoFocus={true}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default IdeaCreateModal;

